import React from 'react';

const NoTradeIcon = () => (
    <span className='icon__compound no-trade'>
        <i className='fas fa-slash'/>
        <i className='fas fa-exchange-alt icon__compound--top-layer'/>
    </span>
);

export default NoTradeIcon;